// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
export const isMacOs = (): boolean => /Mac/i.test(window?.navigator?.platform);
